import { CustomHeaderPolicy } from "./CustomHeaderPolicy";
export const ACCEPT_LANGUAGE_HEADER = 'Accept-Language';
export function createAcceptLanguagePolicy(acceptLanguage) {
  return {
    create: (nextPolicy, options) => new CustomHeaderPolicy(nextPolicy, options, ACCEPT_LANGUAGE_HEADER, acceptLanguage)
  };
}
//# sourceMappingURL=createAcceptLanguagePolicy.js.map